import { useContext } from 'react';
import {
  getFeatureFlagByNameSelector,
  headerTaxoTrendingSearchesSelector,
  progressiveHeaderTaxoTrendingSearchesSelector,
} from 'store/selectors';
import { useAppSelector } from 'store/store';
import { WindowContext } from 'utility/windowContext';
import useTrendingSearchDataFromWindow from './useTrendingSearchDataFromWindow';

const useTrendingSearches = () => {
  // get trending searches data from taxo. It can come from either progressive taxo or the original
  // header taxo depending on whether the desktopProgressiveTaxo feature flag is set
  const progressiveHeaderDesktopEnabled = useAppSelector(
    getFeatureFlagByNameSelector('progressiveTaxoDesktop'),
  );
  const headerTrendingSearches = useAppSelector(headerTaxoTrendingSearchesSelector);
  const progressiveTrendingSearches = useAppSelector(progressiveHeaderTaxoTrendingSearchesSelector);
  const trendingSearchHomrData = progressiveHeaderDesktopEnabled
    ? progressiveTrendingSearches
    : headerTrendingSearches;

  // get trending searches data from the window if it's set
  const { trendingSearchWindowData } = useTrendingSearchDataFromWindow();

  // if window data is present, we'll use that. Otherwise we'll use the homr data
  const trendingSearchData = trendingSearchWindowData ?? trendingSearchHomrData;

  // determine if we're on the homepage and if trending searches is enabled there
  const win = useContext(WindowContext);
  const isHomepage = win?.location.pathname === '/';
  const disableTrendingSearchBarOnHomePage = useAppSelector(
    getFeatureFlagByNameSelector('disableTrendingSearchBarOnHomePage'),
  );

  // determine if trending searches is enabled via feature flag
  const trendingSearchBarEnabled = useAppSelector(
    getFeatureFlagByNameSelector('trendingSearchBarEnabled'),
  );

  // If we're on the homepage and trending searches hasn't been disabled, return the trending search
  // data with "showTrendingSearchData" set to "true"
  if (isHomepage && !disableTrendingSearchBarOnHomePage) {
    return { trendingSearchData, showTrendingSearchData: true };
  }

  // otherwise, if trending searches is enabled by feature flag, return it that way with
  // "showTrendingSearchData" set to true
  if (trendingSearchBarEnabled) {
    return { trendingSearchData, showTrendingSearchData: true };
  }

  // finally, if none of those conditions is true, return the data, but set "showTrendingSearchData"
  // to false
  return { trendingSearchData, showTrendingSearchData: false };
};

export default useTrendingSearches;
